export default "__VITE_ASSET__Dd5395a9__"